import React,{useEffect} from "react";
import { Link } from "react-router-dom";

const Ayuda = () => {
 

    return (

    <div className="bg-white dark:bg-secondary-dark-bg p-4 max-w-4xl mx-auto rounded-2xl shadow-md mt-6">
        <div className="flex flex-col md:flex-row items-center justify-center gap-4">
            <p>Bienvenido a la página de ayuda.</p>

            <Link to="/Ayuda.html" target="_blank" className="text-sm text-gray-500 hover:text-aldoc-blue">
               ¿En qué podemos ayudarte?
            </Link>
        </div>
    </div>
    );
};

export default Ayuda;